import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-jssi-footer',
  templateUrl: './jssi-footer.component.html',
  styleUrls: ['./jssi-footer.component.scss']
})
export class JssiFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/jssi-footer/jssi-footer.component.ts